import { BookOpen, MessageCircle } from 'lucide-react'
import { Card } from '@/components/ui/Card'

interface MomentumOpeningCardProps {
  message: string
}

export function MomentumOpeningCard({ message }: MomentumOpeningCardProps) {
  return (
    <Card
      className="border-primary/20 bg-primary/5 p-4"
      data-testid="momentum-opening-card"
    >
      <div className="flex gap-3">
        <BookOpen className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
        <p className="min-w-0 text-sm leading-relaxed text-foreground">{message}</p>
      </div>
    </Card>
  )
}

interface StepNarrationProps {
  message: string
}

export function StepNarration({ message }: StepNarrationProps) {
  return (
    <div
      className="mb-4 flex gap-2 rounded-lg border border-border/80 bg-muted/40 px-3 py-3 text-sm text-muted-foreground"
      data-testid="step-narration"
    >
      <MessageCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
      <p className="min-w-0 break-words">{message}</p>
    </div>
  )
}
